var React = require('react');

function PivotalUiInverted (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pivotal UI B"),React.createElement("path",{"d":"M105,0,0,60.62V181.86l105,60.62,105-60.62V60.62Zm15.27,199.19-15,8.66-75-43.3V77.94l30-17.32v86.6l30,17.32V43.3l15-8.66,15,8.66Zm60-34.64-30,17.32V60.62l30,17.32Z","style":{"fill":"#00776d"},"key":1})]);
}

PivotalUiInverted.displayName = "PivotalUiInverted";

PivotalUiInverted.defaultProps = {"viewBox":"0 0 210 242.49"};

module.exports = PivotalUiInverted;

PivotalUiInverted.default = PivotalUiInverted;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/pivotal_ui_inverted.svg